import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export var deviceTypes = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop'
};
export var mobileMedia = '(max-width: 767px)';
export var tabletMedia = '(min-width: 768px) and (max-width: 1023px)';
export var desktopMedia = '(min-width: 1024px)';
export var actionTypes = {
  SWITCH_DEVICE_TYPE: 'switch device type'
};
export function deviceTypeReducer(state, _ref) {
  var type = _ref.type,
    deviceType = _ref.deviceType;
  var SWITCH_DEVICE_TYPE = actionTypes.SWITCH_DEVICE_TYPE;
  // eslint-disable-next-line sonarjs/no-small-switch
  switch (type) {
    case SWITCH_DEVICE_TYPE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          deviceType: deviceType
        });
      }
    default:
      return state;
  }
}
export function setMobileType() {
  return {
    type: actionTypes.SWITCH_DEVICE_TYPE,
    deviceType: deviceTypes.MOBILE
  };
}
export function setTabletType() {
  return {
    type: actionTypes.SWITCH_DEVICE_TYPE,
    deviceType: deviceTypes.TABLET
  };
}
export function setDesktopType() {
  return {
    type: actionTypes.SWITCH_DEVICE_TYPE,
    deviceType: deviceTypes.DESKTOP
  };
}
export function addResizeEventListener(store) {
  store.addReducer(deviceTypeReducer);
  if (typeof window !== 'undefined') {
    var switcher = function switcher(mq, action) {
      if (mq.matches) {
        store.dispatch(action());
      }
    };
    if (typeof window.matchMedia === 'function') {
      var mobileMediaQuery = window.matchMedia(mobileMedia);
      var desktopMediaQuery = window.matchMedia(desktopMedia);
      var tabletMediaQuery = window.matchMedia(tabletMedia);
      // Checking type on client.
      switcher(mobileMediaQuery, setMobileType);
      switcher(desktopMediaQuery, setDesktopType);
      switcher(tabletMediaQuery, setTabletType);
      mobileMediaQuery.addListener(function (mq) {
        return switcher(mq, setMobileType);
      });
      desktopMediaQuery.addListener(function (mq) {
        return switcher(mq, setDesktopType);
      });
      tabletMediaQuery.addListener(function (mq) {
        return switcher(mq, setTabletType);
      });
    } else {
      store.dispatch(setDesktopType());
    }
  } else {
    // Set default mobile type for server rendering.
    store.dispatch(setMobileType());
  }
}